<template>
  <div class="noticedialog">
    <div class="notice-content">
      <div class="notice"><div>{{goOnNoticeMessage}}</div>
        <div class="buttons"><div class="sure" @click="sureClose">确 定</div>
      <div class="sure" @click="sureCancel">取 消</div></div>
    </div>
  </div>
  </div>
</template>
<script>
  export default {
    props:[
      "goOnNoticeMessage"
    ],
    methods: {
      sureClose() {
        this.$emit("sureGoOn")
      },
      sureCancel() {
        this.$emit("sureCancel")
      }
    }
  }
</script>
<style scoped>
  .noticedialog {
    position: fixed;
    top: 0;
    bottom:0;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .notice-content {
    margin: 0 auto;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: inline-block;
  }
  .notice {
    border: 50px solid;
    border-image: url(../../assets/notice.png) 60 stretch;
    background: #fff;
    background-clip: padding-box;
    padding: 10px;
    box-sizing: border-box;
  }
  .buttons {
    width:300px;
    margin-top: 20px;
  }
  .sure {
    display: inline-block;
    width: 90px;
    height: 30px;
    line-height: 30px;
    margin: 0 20px;
    background: #27a7ea;
    border-radius: 6px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/noticeconfirm.vue